import { AUTO_PATH, PAIR_PATH } from '../paths';

export const pinCodePageLocalizationMap = {
  [AUTO_PATH]: {
    titleKey: 'auto.pinCode.page.title',
    errorKey: 'auto.pinCode.page.error',
    buttonLabelKey: 'pinCode.page.button.label',
  },
  [PAIR_PATH]: {
    titleKey: 'pinCode.page.title',
    errorKey: 'pinCode.page.error',
    buttonLabelKey: 'pinCode.page.button.label',
  },
};
